<!-- <ng-content></ng-content> -->
<!-- 
<div class="menu-container" style="flex-direction: column; align-items: center;">
  <dx-tree-list style="margin-bottom: 2rem; height: 90vh; width: 100%; border-radius: 30px;" id="sidemenu"
    [dataSource]="lists" keyExpr="id" parentIdExpr="parentId" [rootValue]="null" [showRowLines]="false"
    [showBorders]="false" [columnAutoWidth]="true" [focusedRowEnabled]="true" [autoExpandAll]="false"
    [showColumnHeaders]="false" [rtlEnabled]="currentLang == 'ar' ? true : false" [elementAttr]="{ class: 'side' }"
    [(focusedRowKey)]="focusedRowKey" (onFocusedRowChanged)="onFocusedRowChanged($event)">
    <dxo-search-panel [visible]="true" style="margin-right: 240px;" placeholder="Search..."></dxo-search-panel>

    <dxi-column [dataField]="currentLang == 'ar' ? 'nameAr' : 'nameEn'" cellTemplate="employeeTemplate"></dxi-column>
    <div *dxTemplate="let options of 'employeeTemplate'; let i = index">
      <div style="display: flex; gap: 5px; align-items: center; margin: 0px 0px;">
        <h6 [ngStyle]="{
    'font-size': options.data.externalUrl == '' ? '16px' : '14px',
    'font-weight': options.data.externalUrl == '' ? 'bold' : 'bold'
     }" style="text-decoration: none; color: #000; margin: 0;">

          <i *ngIf="options.data.externalUrl && options.data.externalUrl !== ''" class="fa fa-circle"
            style="font-size: 8px; margin-inline-end: 6px; color: #666;">
          </i>
          <i *ngIf="options.data.externalUrl == ''" class="fa fa-angle-left" style="font-size: 14px; color: #666;">
          </i>
          {{ currentLang == 'ar' ? options.data.nameAr : options.data.nameEn }}
        </h6>
      </div>
    </div>
  </dx-tree-list>
</div> -->


<div class="Menue">
  <div class="header-menue">
    <!-- <img src="assets/icons/ERPh.png" alt="Logo" style="height: 50px;" /> -->
    <img [src]="logoUrl" alt="Logo" style="height: 50px;" />
    <i class="fa-solid fa-xmark" (click)="closeMenue()"></i>
  </div>

  <div class="search">
    <label>Search</label>
    <div>
      <input (input)="Search($event)" dir="rtl" />
      <i class="fa-solid fa-magnifying-glass"></i>
    </div>
  </div>


  <!-- <ul class="menu-tree">
    <ng-container *ngFor="let parent of rootMenus">
      <li>
        ***************************************Level 1*******************************************************
        <div class="flex" (click)="parent.children?.length && toggle(parent.id, $event)">
          <span [routerLink]="parent.externalUrl"><i class="fa icon-menue" [ngClass]="parent.styleClass"></i>{{ parent[textLanguage] }}</span>
          <span *ngIf="parent.children?.length">
            <i class="fa-solid fa-angle-left" [class.rotate]="expanded[parent.id]"></i>
          </span>
        </div>

        <ul *ngIf="expanded[parent.id]" @slideToggle>
          <ng-container *ngFor="let child of parent.children">
            <li>
              ***************************************Level 2*******************************************************
              <div [routerLink]="child.externalUrl" class="flex" [class.has-children]="child.children?.length"
                (click)="child.children?.length && toggle(child.id, $event)">
                <span><i class="fa-solid fa-star"></i>{{ child[textLanguage]}}</span>
                <span *ngIf="child.children?.length">
                  <i class="fa-solid fa-angle-left" [class.rotate]="expanded[child.id]"></i>
                </span>
              </div>

              <ul *ngIf="expanded[child.id]" @slideToggle>
                <ng-container *ngFor="let sub of child.children">
                  <li>
                    ***************************************Level 3*******************************************************
                    <div class="flex" [class.has-children]="sub.children?.length" [routerLink]="sub.externalUrl"
                      (click)="sub.children?.length && toggle(sub.id, $event)">
                      <span><i class="fa-solid fa-star"></i>{{ sub[textLanguage]}}</span>
                      <span *ngIf="sub.children?.length">
                        <i class="fa-solid fa-angle-left" [class.rotate]="expanded[sub.id]"></i>
                      </span>
                    </div>

                    <ul *ngIf="expanded[sub.id]" @slideToggle>
                      <ng-container *ngFor="let sub2 of sub.children">
                        <li>
                          ***************************************Level 4*******************************************************
                          <div  [routerLink]="sub2.externalUrl">
                            <span style="color: white;">{{ sub2[textLanguage] }}</span>
                          </div>
                        </li>
                      </ng-container>
                    </ul>
                  </li>

                  
                </ng-container>
              </ul>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul> -->


<!--*********************************Composite Pattern************************************************-->
  <ul class="menu-tree">
    <ng-container *ngTemplateOutlet="showItems; context:{ $implicit: rootMenus }"></ng-container>
  </ul>

  <ng-template #showItems let-items>
    <ng-container *ngFor="let item of items">
      <li>
        <div (click)="item.children?.length && toggle(item.id, $event) && setActive(item.id)"
          [routerLink]="!item.children?.length ? item.externalUrl : null" class="flex"
          [class.active]="activeItemId === item.id" routerLinkActive="active">

          <span class="flex-content">
            <span>
              <i class="icon-date fa" [ngClass]="item.styleClass"></i>
              <span *ngIf="item.styleClass==''|| !item.styleClass" class="circle"></span>
            </span>
            <span>{{ item[textLanguage] }}</span>
          </span>

          <span *ngIf="item.children?.length">
            <i class="fa-solid fa-angle-left" [class.rotate]="expanded[item.id]"></i>
          </span>
        </div>

        <ul *ngIf="expanded[item.id]" @slideToggle>
          <ng-container *ngTemplateOutlet="showItems; context:{ $implicit: item.children }"></ng-container>
        </ul>
      </li>
    </ng-container>
  </ng-template>
<!--*********************************Composite Pattern************************************************-->

</div>